<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">To<br/>Lieutenant (“Leftenant”) Commander Julie Vitali, Royal Navy,<br/>who would’ve made one hell of a pirate,<br/>and who wrote the book on Yankees.<br/><br/>For S, as always</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?f0eb194c